
import React from 'react';
var redirectURL = require('../redirectURL');

const Allactionsuperadmincomponent = (props) => {
  const context = props.context.componentParent;
  const indent = props.data.indent || {};
  const unreadCount = indent.notification_count;

  const handleClick = (type, e) => {
    e.stopPropagation();

    switch (type) {
      case 'material':
        context.onClickshowbiddata(props);
        break;
      case 'attachment':
        context.onClickViewPOD(props);
        break;
      case 'comment':
        context.onClickComments(props);
        break;
      case 'bidding':
        context.onClickviewRFQ(props);
        break;
      case 'notification':
        context.fetchNotificationsData(props);
        break;
      case 'cancelindent':
        context.cancelindent(indent);
        break;
       case 'commentsall':
        context.onClickallcomments(props);
        break;
      default:
        break;
    }
  };

  const isBiddingWindowExpired = (biddingWindow, createDate) => {
    if (!biddingWindow || !biddingWindow.includes(':') || !createDate) return true;

    const [hours, minutes] = biddingWindow.split(':').map(Number);
    if (isNaN(hours) || isNaN(minutes)) return true;

    const localCreateDate = new Date(createDate.replace('Z', '') + '+05:30');
    const biddingEndTime = new Date(localCreateDate);
    biddingEndTime.setHours(biddingEndTime.getHours() + hours);
    biddingEndTime.setMinutes(biddingEndTime.getMinutes() + minutes);

    return new Date() > biddingEndTime;
  };

  const hasComments = [
    indent.additional_comments,
    indent.reasonforrejectionbyvendor,
    indent.rejected_reason_by_approval1,
    indent.rejection_reason_for_superadmin,
  ].some((val) => val && val.trim() !== '');
const hasComments1 = [
    indent.reasonforrejectionbyvendor,
    indent.adminbifurComment,
    indent.rejected_reason_by_approval1,
    indent.rejection_reason_for_superadmin,
  ].some((val) => val && val.trim() !== '');

  return (
    <div style={{ display: 'flex', gap: '5px', position: 'relative' }}>
      {/* Bid */}
      {indent.is_draft==1?'':
      <button
        onClick={(e) => {
          if (
            Array.isArray(indent.vendorquotes) &&
            indent.vendorquotes.length > 0 &&
            isBiddingWindowExpired(indent.bidding_window, indent.create_date)
          ) {
            handleClick('material', e);
          }
        }}
        className="custom-btn label label-success"
        title="Bid Details"
      >
        {Array.isArray(indent.vendorquotes) &&
        indent.vendorquotes.length > 0 &&
        isBiddingWindowExpired(indent.bidding_window, indent.create_date) ? (
          <img
            src={require('../../assets/images/Group 976.png')}
            style={{ cursor: 'pointer', position: 'relative' }}
            alt="Bid Details"
          />
        ) : (
          <img
            src={require('../../assets/images/biddetailsdisable.png')}
            style={{ cursor: 'not-allowed', position: 'relative' }}
            alt="Bid Details"
          />
        )}
      </button>}

      {/* Attachment */}
      <button
        onClick={(e) => {
          if (indent.upload_for_road && indent.upload_for_road !== '') {
            handleClick('attachment', e);
          }
        }}
        className="custom-btn label label-success"
        title="Download"
      >
        {indent.upload_for_road && indent.upload_for_road !== '' ? (
          <img
            src={require('../../assets/images/downloadenable.png')}
            style={{ cursor: 'pointer', position: 'relative' }}
            alt="Attachment"
          />
        ) : (
          <img
            src={require('../../assets/images/downloading.png')}
            style={{ cursor: 'not-allowed', position: 'relative' }}
            alt="Attachment"
          />
        )}
      </button>

      {/* Comments */}
      {hasComments ? (
        <button
          onClick={(e) => handleClick('comment', e)}
          className="custom-btn label label-success"
          title="Comments"
        >
          <img
            src={require('../../assets/images/chat.png')}
            style={{ cursor: 'pointer' }}
            alt="Comments"
          />
        </button>
      ) : (
        <button
          disabled
          className="custom-btn label label-secondary"
          title="No Comments"
          style={{ cursor: 'not-allowed' }}
        >
          <img
            src={require('../../assets/icons/chat.png')}
            style={{ opacity: 0.5 }}
            alt="No Comments"
          />
        </button>
      )}
     
     {indent.is_draft==1?'':<>
      {/* View RFQ */}
      <button
        onClick={(e) => handleClick('bidding', e)}
        className="custom-btn label label-success"
        title="View Indent"
      >
        <img
          src={require('../../assets/images/viewindent.png')}
          style={{ cursor: 'pointer', position: 'relative' }}
          alt="RFQ"
        />
      </button>

      {/* Cancel Indent */}
      {/* <div style={{ position: 'relative' }}>
        <button
          onClick={(e) => handleClick('cancelindent', e)}
          className="custom-btn label label-success"
          title="Reject Indent"
        >
          <img
            src={require('../../assets/images/forbidden.svg')}
            style={{ cursor: 'pointer', position: 'relative' }}
            alt="Cancel"
          />
        </button>
      </div> */}

      {/* Notifications */}
      <div
  style={{
    position: 'relative',
    display: 'inline-block',
    cursor: indent.notificationdatamap === 0 ? 'not-allowed' : 'pointer'
  }}
  onClick={(e) => {
    if (indent.notificationdatamap && indent.notificationdatamap !== 0) {
      handleClick('notification', e);
    }
  }}
  title="Notifications"
>
  <img
    src={
      indent.notificationdatamap === 0
        ? require('../../assets/images/disablenotification.svg')
        : require('../../assets/images/notifications.png')
    }
    style={{
      position: 'relative',
      pointerEvents: 'none' // prevents image itself from handling the click
    }}
    alt="Notifications"
  />

  {unreadCount > 0 && (
    <span
      style={{
        position: 'absolute',
        right: '-8px',
        top: '-1px',
        backgroundColor: 'red',
        color: 'white',
        borderRadius: '50%',
        padding: '2px 4px',
        fontSize: '8px',
        fontWeight: 'bold',
        lineHeight: '1',
        // removed pointerEvents: 'none' to allow clicks
      }}
    >
      {unreadCount}
    </span>
  )}
</div>
 {hasComments1 ? (
        <button
          onClick={(e) => handleClick('commentsall', e)}
          className="custom-btn label label-success"
          title="Logs"
        >
                       <i className="icofont icofont-history f18" style={{ cursor: 'pointer' }}
></i> 

        </button>
      ) : (
        <button
          disabled
          className="custom-btn label label-secondary"
          title="Logs"
          style={{ cursor: 'not-allowed' }}
        >
                <i className="icofont icofont-history f18"  style={{ cursor: 'pointer' }}
></i> 

        </button>
      )}


</>}
    </div>
  );
};

export default Allactionsuperadmincomponent;

